import { Input } from '@squire/ui';

import { withBottomSheetInput } from '@/utils/withBottomSheetInput';

export const BottomSheetInput = withBottomSheetInput(Input);
